import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                flight: undefined,
                fetchStatus: "loading",
                error: undefined
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                flight: action.payload.flight,
                fetchStatus: "success",
                error: undefined
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                error: action.payload.error,
                flight: undefined
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
